/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_init = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/**
		Unbind: Unnecessary listeners
		**/
		//$(document).off('click.cookieWallSubmit');
		//$(document).off('click.cookieWallTabs');
		//$(document).off('click.cookieBarSubmit');
		
		/*
		Close the mobilemenu always on route
		*/
		specific_mobilemenu.toggle(1);

		/*
		Catch and active URL
		*/
		specific_interactions.catchAndActiveURL();

		/*
		Swiper JS: Spotlight
		*/
		/*
		Swiper JS
		*/
		var swiper_spotlight = new Swiper('.js-swiper-spotlight', {
			
			slidesPerView: 4,
			spaceBetween: 50,
			centeredSlides: true,
			loop: true,
	  
			autoplay: {
				delay: 2000,
			},
			
			breakpoints: {
			    // when window width is >= 320px
				100: {
					slidesPerView: 2,
					spaceBetween: 25
			    },
			    // when window width is >= 480px
				// 480: {
				// 	slidesPerView: 4,
				// 	spaceBetween: 10
			    // },
			    // when window width is >= 640px
				640: {
					slidesPerView: 4,
					spaceBetween: 50
				}

			},

			on: {
	          init: function () {
	            $('.js-swiper-spotlight').animate({'opacity':1});
	          }
	        }
		});
		
	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_init); 
